import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from "@angular/forms";
import { RemnantsComponent } from './remnants.component';
import { AuthGuardService } from '../shared/services/auth-guard.service';
import { RemnantsService } from './remnants.service';
import { RemnantPricePipe } from './remnant-price-pipe';

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    RouterModule.forChild([
      { path: 'remnants', component: RemnantsComponent, canActivate:[AuthGuardService] }
    ])
  ],
  providers: [
    RemnantsService
  ],
  declarations: [RemnantsComponent, RemnantPricePipe]
})
export class RemnantsModule { }



// WEBPACK FOOTER //
// ./src/app/remnants/remnants.module.ts